var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82,
    height: 68,
    viewBox: "0 0 82 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3159",
    "data-name": "Rectangle 3159",
    width: 82,
    height: 68,
    transform: "translate(-0.139 0.051)",
    fill: "#77ffa5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11104",
    "data-name": "Group 11104",
    transform: "translate(-0.061 -0.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11103",
    "data-name": "Group 11103",
    transform: "translate(0.2 0.074)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28996",
    "data-name": "Path 28996",
    d: "M71.349,66.01a2.967,2.967,0,0,0,.223-.582L81.8,24.53a4.1,4.1,0,0,0-.673-2.713,3.1,3.1,0,0,0-2.736-1.368H71.572V10.225a3.225,3.225,0,0,0-3.408-3.408H30.674V3.408A3.225,3.225,0,0,0,27.265,0H3.408A3.225,3.225,0,0,0,0,3.408V64.755c0,.132.055.236.064.364a4.129,4.129,0,0,0,.082.464A3.1,3.1,0,0,0,1.2,67.4a2.919,2.919,0,0,0,.75.482c.068.027.136.041.2.068a3.766,3.766,0,0,0,1.25.218H68.164a3.76,3.76,0,0,0,1.272-.223,3.461,3.461,0,0,0,.513-.273,3.4,3.4,0,0,0,.527-.345,2.762,2.762,0,0,0,.341-.386,3.024,3.024,0,0,0,.441-.682,2.262,2.262,0,0,0,.091-.245M6.816,6.816H23.857v3.408a3.225,3.225,0,0,0,3.408,3.408h37.49v6.816H13.633a3.323,3.323,0,0,0-3.408,2.736L6.816,36.817ZM7.848,61.347l8.52-34.082h57.58l-8.52,34.082Z",
    transform: "translate(-0.075 -0.063)",
    fill: "#77ffa5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon14.0dad882c8a7173ee82ed3d41d1398914.svg";
export { ForwardRef as ReactComponent };